module.exports = __webpack_public_path__ + "static/media/marketplace_art.ea5a576b.svg";